import Carousel from '@/components/carousel/Carousel'
import Divider from '@/components/divider/Divider'
import Image from '@/components/image/Image'
import theme from '@/components/themes/mainTheme'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid2'
import Link from '@mui/material/Link'
import React from 'react'
import { useMediaQuery } from 'react-responsive'
// @ts-expect-error It works
import HistoryPdf from '/documents/Handlingplan-Vid-Krankning.pdf'

const consertsImages = [
  '/images/history/ostersjofestivalen-1.jpg',
  '/images/history/ostersjofestivalen-2.jpg',
  '/images/events/christmas-eve.jpg',
]

const fikaImages = [
  '/images/statics/fika.jpg',
  '/images/statics/lubeck-fika.jpg',
  '/images/statics/barbeque.jpg',
]

const About: React.FC = () => {
  const isMobile = useMediaQuery({
    query: `(max-width: ${theme.breakpoints.values.md}px)`,
  })
  return (
    <Grid
      container
      direction="column"
      columnSpacing={2}
      justifyContent="center"
      alignItems="center"
      textAlign="center"
    >
      <Grid size={10}>
        <h1>Om oss & vår musik</h1>
      </Grid>

      <Grid size={{ xs: 11, md: 6 }} textAlign="start">
        <p>
          Karlshamns Scoutmusikkår är en ideell förening där spelglädje,
          gemenskap och musiktradition står i centrum. Vi samlar musiker i alla
          åldrar, från nybörjare till erfarna, och spelar tillsammans på
          konserter, parader och evenemang. Vår repertoar är bred - vi leker med
          allt från svensk marschmusik till svängiga toner från andra delar av
          världen. Hos oss handlar det inte bara om att spela musik, utan också
          om att ha roligt, utvecklas och skapa minnen tillsammans.
        </p>
      </Grid>

      <Grid size={{ xs: 11, md: 10 }}>
        <h3>Nuvarande uppsättning</h3>
        <Image
          src="/images/statics/groupimage-2024.jpg"
          alt="Gruppbild"
          loading="eager"
          skeletonHeight={821}
        />
        <p>
          <b>Bakre raden, från vänster: </b>
          Jojo Berghall, Johan Jansson, Karl Jansson, Elin Jonasson, Erik
          Ståhlberg, Nils Bjersten, Klara Dahlin, Per Truedsson, Emma Karlsson,
          Povel Andersson, Ismael Buoachmir, Rune Svensson, Magnus Johansson,
          Peter Westermark, Martin Falk
        </p>
        <p>
          <b>Främre raden, från vänster: </b>
          Lotta Graveley, Katarina Galle Barrett, Kristina Ståhlberg, Annie
          Gryth, Christer Petersson, Mattias Kouzmine, Anders Fagerström,
          Jonathan Winkler, Mats Mattisson
        </p>
        <p>
          <b>Liggandes, från vänster: </b>
          William Petersson, Filip Loci Jonsson
        </p>
        <p>
          <b>Ej i bild: </b>
          Alex Bringsarve, Isabella Svenesson, My Oredsson
        </p>
      </Grid>

      <Divider size={{ xs: 11, md: 8 }} />

      <Grid size={{ xs: 11, md: 8 }}>
        <Image src="/images/statics/fika-3.jpg" alt="Fikabild" />
        <i>Varför öva när man kan fika!</i>
      </Grid>

      <Divider size={{ xs: 11, md: 8 }} />

      <Grid size={{ xs: 11, md: 4 }}>
        <h2>Vi lär ut och utvecklar musikkunskap</h2>
        <p style={{ textAlign: 'left' }}>
          <b>Repetitioner:</b> Måndagar 18:30-ca 20:45, med insluss från 17:30
        </p>
        <p style={{ textAlign: 'left' }}>
          <b>Bred repertoar:</b>
          Allt från gammal svensk marschmusik till afroamerikanskt sväng och
          balkangung
        </p>

        <p style={{ textAlign: 'left' }}>
          <b>En gemenskap:</b>
          Här bidrar alla på sitt sätt. Läs mer om vår gemenskap och våra
          riktlinjer.
        </p>
        <a
          href={HistoryPdf}
          download="/documents/Handlingplan-Vid-Krankning.pdf"
          target="_blank"
          rel="noreferrer"
        >
          <Button
            variant="contained"
            sx={{
              color: '#FFFFFF',
              width: 150,
              height: 40,
            }}
          >
            <>
              Ladda ner <PictureAsPdfIcon />
            </>
          </Button>
        </a>
      </Grid>

      <Divider size={{ xs: 11, md: 8 }} />

      <Grid size={{ xs: 11, md: 3 }}>
        <h2>Uppstart</h2>
        <p style={{ textAlign: 'start' }}>
          <b>Vårterminen:</b> Börjar repeterar i Januari
          <br />
          <b>Höstterminen:</b> Börjar repeterar i Augusti
          <br />
          <Link href="/members">
            <b>Klicka här för program</b>
          </Link>
        </p>
      </Grid>

      <Grid
        container
        direction="row"
        size={{ xs: 11, md: 8 }}
        justifyContent="center"
        alignItems="center"
        textAlign="center"
      >
        <Grid size={{ xs: 12, md: 4 }}>
          <h3>Konserter, marscher & parader</h3>
        </Grid>

        {isMobile ? (
          <Grid container direction="column" size={{ xs: 12, md: 4 }}>
            <Carousel images={consertsImages} />
          </Grid>
        ) : (
          <>
            <Grid container direction="column" size={{ xs: 12, md: 4 }}>
              <Grid size={12}>
                <Image
                  src="/images/history/ostersjofestivalen-1.jpg"
                  alt="Östersjöfestivalen 1"
                />
              </Grid>
              <Grid size={12}>
                <Image
                  src="/images/history/ostersjofestivalen-2.jpg"
                  alt="Östersjöfestivalen 2"
                />
              </Grid>
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <Image src="/images/events/christmas-eve.jpg" alt="Julafton" />
            </Grid>
          </>
        )}
      </Grid>

      <Grid
        container
        direction="row"
        size={{ xs: 11, md: 8 }}
        justifyContent="center"
        alignItems="center"
        textAlign="center"
      >
        <Grid
          size={{ xs: 12, md: 4 }}
          sx={{ display: { xs: 'block', md: 'none' } }}
        >
          <h3>Fika, häng och föreningsliv</h3>
        </Grid>

        {isMobile ? (
          <Grid container direction="column" size={{ xs: 12, md: 4 }}>
            <Carousel images={fikaImages} />
          </Grid>
        ) : (
          <>
            <Grid size={{ xs: 12, md: 4 }}>
              <Image src="/images/statics/fika.jpg" alt="Fika" />
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <Image src="/images/statics/barbeque.jpg" alt="Grillning" />
            </Grid>
            <Grid
              size={{ xs: 12, md: 4 }}
              sx={{ display: { xs: 'none', md: 'block' } }}
            >
              <h3>Fika, häng och föreningsliv</h3>
            </Grid>
          </>
        )}
      </Grid>
    </Grid>
  )
}

export default About
